import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';

export const SkillLevel = ({ value, onChange, editMode = false }) => {
  const levels = [
    { id: 'basic', label: 'Basic', image: '/symbols/skill-level-basic.jpg' },
    { id: 'easy', label: 'Easy', image: '/symbols/skill-level-easy.jpg' },
    { id: 'intermediate', label: 'Intermediate', image: '/symbols/skill-level-intermediate.jpg' },
    { id: 'complex', label: 'Complex', image: '/symbols/skill-level-complex.jpg' },
  ];

  if (editMode) {
    return (
      <FormControl fullWidth margin="normal">
        <InputLabel>Skill Level</InputLabel>
        <Select
          value={value || ''}
          onChange={(e) => onChange('skillLevel', e.target.value)}
          label="Skill Level"
          size="small"
        >
          {levels.map((level) => (
            <MenuItem key={level.id} value={level.id}>
              <Box display="flex" alignItems="center">
                <img src={level.image} alt={level.label} style={{ height: 24, marginRight: 8, objectFit: 'contain' }} />
                {level.label}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }


  const selectedLevel = levels.find(l => l.id === value);
  if (!selectedLevel) return null;

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Skill Level</Typography>
      <img src={selectedLevel.image} alt={selectedLevel.label} style={{ height: 30, objectFit: 'contain' }} />
    </Box>
  );
};

export default SkillLevel;
